import { Button, Card, Col, Container, Row } from "react-bootstrap";
// import { ReadMore } from "../../components/ReadMore";
import Image from "react-bootstrap/Image";
import { motion } from "framer-motion";
import { ExpandableComponent } from "../../components/ExpandableComponent";
import { useEffect } from "react";
import developmentsJSON from "./developmentsData.json";

import { firestoreDB } from "../../App";
import { doc, updateDoc, increment } from "firebase/firestore";

interface Software {
  sectionid: string;
  name: string;
  initialReleaseDate: string;
  intro: string;
  features: string[];
  images?: string[];
  downloadLink?: string;
  versions?: {
    version: string;
    date: string;
    link: string;
    description: string[];
  }[];
}

export const Developments = () => {
  useEffect(() => {
    document.title = "Mohamad Tarabin - Developments";
  }, []);

  // This fixes the scrolling when the Home page directs to the development page with a specific #sectionid
useEffect(() => {
  if (window.location.hash) {
    const id = window.location.hash.substring(1);

    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  }
}, []);

  const trackDownload = async (softwareName: string) => {
  const downloadRef = doc(firestoreDB, "downloads", "all_software");
  await updateDoc(downloadRef, {
    [softwareName]: increment(1),
  });
  };

  const softwareList: Software[] = developmentsJSON.software;

  return (
    <>
      <Container>
       <h3 style={{ marginTop: "30px", marginBottom: "30px" }}>
         Developments {" "}
        <span style={{ color: "gray" }}>({softwareList.length})</span>
       </h3>

        <div className="publications-container">
          {softwareList.map((software, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1.5 }}
            viewport={{ once: true}}
          >
            
            <Card className="mb-4" id={software.sectionid}>
              <Card.Body>
                <Container fluid>

                  {/* This row shows all software details. Next row is for the download */}
                  <Row>
                    {/* LEFT SIDE */}
                    <Col xs={12} lg={7}>
                      <Card.Title className="fw-bold">
                        {software.name}
                      </Card.Title>

                      <Card.Text className="mt-3 justify-text">
                      {software.intro}

                      <div className="fw-bold mt-3">Key features:</div>
                      <ul>
                        {software.features.map((f, idx) => (
                          <li key={idx}>{f}</li>
                        ))}
                      </ul>
                      </Card.Text>
                    </Col>

                    {/* RIGHT SIDE (IMAGES) */}
                    <Col>
                      {software.images?.map((img, idx) => (
                        <Row key={idx}>
                          <Image src={img} fluid className="my-2" />
                        </Row>
                      ))}
                    </Col>
                  </Row>

                  {/* DOWNLOAD BUTTON SECTION */}
                  <Row className="mt-4">
                      {software.downloadLink ? (
                        <a
                          href={software.downloadLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={() => trackDownload(software.sectionid)}
                        >
                          <Button className="d-block mx-auto" variant="primary" style={{ width: "85%" }}>
                            Download software
                          </Button>
                        </a>
                      ) : (
                          <ExpandableComponent
                            closedStateText="Download software"
                            openedStateText="Download software"
                            buttonVarient="primary"
                            buttonClassName="d-block mx-auto"
                            buttonStyle={{ width: "85%" }}
                          >

                          {software.versions?.map((v, idx) => (
                            <Card key={idx} className="mt-4">
                              <Card.Header>
                                Version {v.version}
                              </Card.Header>
                              <Card.Body>
                                <Card.Subtitle className="muted-text">
                                  Released {v.date}
                                </Card.Subtitle>
                                <br/>

                                <ul>
                                  {v.description.map((d, i) => (
                                    <li key={i}>{d}</li>
                                  ))}
                                </ul>

                                <a
                                  href={v.link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  onClick={() => trackDownload(software.sectionid)}
                                >
                                  <Button variant="primary">
                                    Download v{v.version}
                                  </Button>
                                </a>
                              </Card.Body>
                            </Card>
                          ))}
                      </ExpandableComponent>
                      )}
                  </Row>
                </Container>
              </Card.Body>
            </Card>


          </motion.div>
            ))}
        </div>


      </Container>
    </>
  );
};

